{
    "Accessibility Menu": "접근성 메뉴",
    "Reset settings": "설정 초기화",
    "Close": "닫기",
    "Content Adjustments": "컨텐츠 조정",
    "Adjust Font Size": "글꼴 크기 조정",
    "Highlight Title": "제목 강조",
    "Highlight Links": "링크 강조",
    "Readable Font": "읽기 쉬운 글꼴",
    "Color Adjustments": "색상 조정",
    "Dark Contrast": "어두운 대비",
    "Light Contrast": "밝은 대비",
    "High Contrast": "높은 대비",
    "High Saturation": "높은 채도",
    "Low Saturation": "낮은 채도",
    "Monochrome": "단색",
    "Tools": "도구",
    "Reading Guide": "읽기 가이드",
    "Stop Animations": "애니메이션 중지",
    "Big Cursor": "큰 커서",
    "Increase Font Size": "글꼴 크기 증가",
    "Decrease Font Size": "글꼴 크기 감소",
    "Letter Spacing": "자간",
    "Line Height": "줄 간격",
    "Font Weight": "글꼴 두께",
    "Dyslexia Font": "난독증 글꼴",
    "Language": "언어",
    "Open Accessibility Menu": "접근성 메뉴 열기"
}
